import { render, staticRenderFns } from "./InputfieldSelect.vue?vue&type=template&id=a5fe6e06&scoped=true&"
import script from "./InputfieldSelect.vue?vue&type=script&lang=js&"
export * from "./InputfieldSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe6e06",
  null
  
)

export default component.exports